import http from '@/services/http';
import apiEndpoints from '@/services/apiEndpoints';

const getDefaultState = () => {
  return {
    systemSettings: [],
    currentSetting: {},
  };
};

const state = getDefaultState();

const getters = {
  systemSettings (state) {
    return state.systemSettings;
  },
  currentSetting (state) {
    return state.currentSetting;
  },
  // Get setting value by key from systemSettings array
  getSettingByKey: (state) => (key) => {
    const setting = state.systemSettings.find(setting => setting.setting_key === key);
    return setting
      ? setting.setting_value
      : null;
  },
  // Get contact request success message from system settings
  contactRequestSuccessMessage (state) {
    const setting = state.systemSettings.find(setting => setting.setting_key === 'contact_success_message');
    return setting
      ? setting.setting_value
      : 'お問い合わせを送信しました。'; // Default message in Japanese
  },
};

const mutations = {
  SET_SYSTEM_SETTINGS (state, settings) {
    state.systemSettings = settings;
  },
  SET_CURRENT_SETTING (state, setting) {
    state.currentSetting = setting;
  },
  CLEAR_SYSTEM_SETTINGS (state) {
    state.systemSettings = [];
    state.currentSetting = {};
  },
};

const actions = {
  async getSystemSettings ({ commit }, keys = []) {
    const params = keys.length > 0
      ? { keys }
      : {};

    const res = await http.get(apiEndpoints.getSystemSettings, { params });
    const { status, data } = res;

    if (status) {
      commit('SET_SYSTEM_SETTINGS', data.data);
      return { status: true, data: data.data };
    } else {
      return { status: false, error: res };
    }
  },

  // Get specific system settings for app initialization
  async initializeSystemSettings ({ commit }) {
    const requiredKeys = ['contact_success_message'];

    const res = await http.get(apiEndpoints.getSystemSettings, {
      params: { keys: requiredKeys },
    });
    const { status, data } = res;

    if (status) {
      commit('SET_SYSTEM_SETTINGS', data.data);
      return { status: true, data: data.data };
    } else {
      return { status: false, error: res };
    }
  },

  async getSystemSettingByKey ({ commit }, key) {
    const res = await http.get(apiEndpoints.getSystemSettingByKey.replace('{key}', key));
    const { status, data } = res;

    if (status) {
      commit('SET_CURRENT_SETTING', data.data);
      return { status: true, data: data.data };
    } else {
      return { status: false, error: res };
    }
  },

  clearSystemSettings ({ commit }) {
    commit('CLEAR_SYSTEM_SETTINGS');
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
